import { get } from 'lodash';
import { FORUM_APP_ID } from '../constants/applications';

export const getUserRoleByApp = (user, appDefinitionId) => get(user, `appStore[${appDefinitionId}].permissions.role`);
export const getUserRole = user => {
  return getUserRoleByApp(user, FORUM_APP_ID) || get(user, 'permissions.role');
};



// WEBPACK FOOTER //
// ./app/services/user-role.js